import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useAdminEnrollmentManagementState() {
  return useAppState();
}

export function useAdminEnrollmentManagementActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      users: [],
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response, loading: false }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback, loading: false }));
  }

  return {
    initializeState,
    onResponse,
    onError,
  };
}
